export enum UpdateRings {
  NONE = -1,
  PRODUCTION_RING = 3,
  TEST1_RING = 4,
  TEST2_RING = 5,
}
